import { useState, useEffect } from 'react'
import MediaCard from '../../../components/MediaCard/MediaCard'
import { fetchGalleryVideos } from '../../../services/api'
import style from './videogallerygrid.module.scss'
import PaginationControl from '../../../components/PaginationControl/PaginationControl'

const VideoGalleryGrid = () => {
    const [videos, setVideos] = useState([])
    const [loading, setLoading] = useState(true)
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        const loadVideos = async () => {
            setLoading(true)
            try {
                const { data, pagination } = await fetchGalleryVideos({
                    page: currentPage,
                    pageSize: 3
                })
                
                // Format the data to handle Strapi's nested structure
                const formattedVideos = data.map(item => ({
                    id: item.id,
                    title: item.attributes.Title || 'Video', // Default title if none exists
                    videoUrl: item.attributes.Video?.data?.attributes?.url
                        ? `${item.attributes.Video.data.attributes.url}`
                        : null
                }))
                
                setVideos(formattedVideos)
                setPagination(pagination)
            } catch (error) {
                console.error('Failed to load videos:', error)
            } finally {
                setLoading(false)
            }
        }

        loadVideos()
    }, [currentPage])

    return (
        <div className={style.imagegallerygrid}>
            <div className={style.wrapperImages}>
                {loading ? (
                    <div>Loading videos...</div>
                ) : (
                    videos.map(item => (
                        <MediaCard
                            key={item.id}
                            title={item.title}
                            media={item.videoUrl}
                            width='90%'
                            isVideo={true}
                        />
                    ))
                )}
            </div>
            {pagination.pageCount > 1 && (
                <div className={style.wrapperBtn}>
                    <PaginationControl
                        page={currentPage}
                        setPage={setCurrentPage}
                        pageCount={pagination.pageCount}
                    />
                </div>
            )}
        </div>
    )
}

export default VideoGalleryGrid